import { Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import Service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import {
  setRockedCurriculumSelectedTenure,
  setRockedCurriculumTenures,
  showProgress,
} from '../../redux/actions/DealershipActions';
import ShowProgress from '../ui/Backdrop';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  tenureHeading: {
    width: '100%',
    height: '50px',
    background: '#f3f4f7',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0px 10px',
  },
  tenuresList: {
    margin: '20px 0px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  tenureCard: {
    background: '#f3f4f7',
    padding: '10px',
    width: '90%',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  tenureJourneyCount: {
    fontSize: '12px',
  },
  selectedTenure: {
    border: '1px solid #BEB3FF',
    background: '#F4F3FF',
    padding: '10px',
    width: '90%',
    borderRadius: '10px',
    cursor: 'pointer',
  },
}));

export default function Tenure() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const roleDetails = useSelector((state) => state.rockedCurriculumData.selectedRole);
  const tenureSelected = useSelector((state) => state.rockedCurriculumData.selectedTenure);
  const tenures = useSelector((state) => state.rockedCurriculumData.tenures);

  const getTenure = async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.RC_YOE.replace('ID', roleDetails.id));
      dispatch(setRockedCurriculumTenures(res));
      handleListItemClick(res[0]);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (roleDetails?.id) {
      getTenure();
    }
  }, [roleDetails]);

  const handleListItemClick = async (data = {}) => {
    dispatch(showProgress(true));
    if (!_isEmpty(data)) {
      dispatch(setRockedCurriculumSelectedTenure(data));
    }
    dispatch(showProgress(false));
  };

  return (
    <Grid container>
      <Grid className={classes.tenureHeading}>
        <Typography variant="h6">Tenure</Typography>
      </Grid>
      <Grid className={classes.tenuresList}>
        {tenures?.map((data) => (
          <Grid
            className={data.id === tenureSelected?.id ? classes.selectedTenure : classes.tenureCard}
            key={data.id}
            onClick={() => handleListItemClick(data)}
          >
            <Typography>{data.yearsOfExperienceTitle}</Typography>
            <Typography variant="p" className={classes.tenureJourneyCount}>
              {data.collectionCount} {data.collectionCount < 2 ? 'Collection' : 'Collections'}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <ShowProgress />
    </Grid>
  );
}
